module.exports = __webpack_public_path__ + "90053a11065825e3058b55f41656e255.svg";